module.exports = __webpack_public_path__ + "img/box2_renwu.6b757a6d.png";